import type { SearchNewItemDataRow, SearchNewItemParams } from "./types";

export function sortByName(
  a: SearchNewItemDataRow | null,
  b: SearchNewItemDataRow | null,
) {
  if (!a || !b) return 0;
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
}

function matchName(name: string, paramName?: string, lang?: string): boolean {
  // if row doesn't have a name, skip it
  if (!name) return false;
  // always return everything if no param name
  if (!paramName) return true;

  // if language is provided, use locale name
  if (lang)
    return name
      .toLocaleLowerCase(lang)
      .includes(paramName.toLocaleLowerCase(lang));
  return name.toLowerCase().includes(paramName.toLowerCase());
}

export function paginate(rows: any[], pageSize: number, pageNumber: number) {
  return rows.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
}

export function sortFilterAndPaginate(
  rows: SearchNewItemDataRow[],
  params: SearchNewItemParams,
  lang?: string,
): SearchNewItemDataRow[] {
  const { name: paramName, pageSize, pageNumber } = params.variables;
  return paginate(
    rows
      .filter((row) => row && matchName(row.name, paramName, lang))
      .sort(sortByName),
    pageSize,
    pageNumber,
  );
}
